import React, { useContext, useEffect, useState } from 'react'
import CheckBox from '@/product/components/atoms/CheckBox'
import CommonContext from '@/custom/context/common/commonContext'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import { useFormik } from 'formik'
import UserContext from '@/product/context/user/userContext'
import AuthContext from '@/product/context/auth/authContext'

import { SITE_NAME } from '@/utils/'
import DashboardLayout from '../DashboardLayout'
import SEO from '@/utils/SEO'
import { Box, Button, Checkbox, Link, Modal, styled, Typography } from '@material-ui/core'
import { handleRedirectInternal } from '@/product/common/components'
import { useHistory } from 'react-router-dom'

function Notifications() {
    const commonContext = useContext(CommonContext)
    const authContext = useContext(AuthContext)

    const userContext = useContext(UserContext)

    const [reload, setReload] = useState(false)

    const [isMaxOpen, setIsMaxOpen] = useState(false)
    const [isSavedOpen, setIsSavedOpen] = useState(false)
    const { user, loadUser } = authContext
    const { allNotifications } = commonContext
    const { updatePreference, responseStatus: responseStatusUser } = userContext
    const WavyCheckIcon = () => <img className="tickMark" src="/assets/images/tickMark.svg" />

    const CustomCheckbox = styled(Checkbox)({
        '&.MuiCheckbox-root': {
            borderRadius: 5,
            border: '2px solid black',
            padding: 0,
            width: 24,
            height: 24,
        },
        '&.Mui-checked': {
            color: 'black',
        },
        '& .MuiSvgIcon-root': {
            fontSize: 28,
        },
    })

    //update Notification settings
    const formikPreference = useFormik({
        initialValues: {
            email_prefer: [],
            sms_prefer: [],
        },
        onSubmit: (values) => {
            updatePreference(values)
        },
    })

    useEffect(() => {
        if (user) {
            formikPreference.values.email_prefer =
                user.email_notification && user.email_notification.split(',').length
                    ? user.email_notification.split(',')
                    : []
            formikPreference.values.sms_prefer =
                user.sms_notification && user.sms_notification.split(',').length
                    ? user.sms_notification.split(',')
                    : []
            setReload(!reload)
        }
    }, [user])

    useEffect(() => {
        if (responseStatusUser) {
            if (responseStatusUser.from === 'updatePreference') {
                if (responseStatusUser.status === 'success') {
                    loadUser()
                }
            }
        }
    }, [responseStatusUser])
    const history = useHistory()
    const handleOpenMax = (data) => {
        if (data == 'Saved Search') {
            setIsSavedOpen(!isSavedOpen)
        } else {
            setIsMaxOpen(!isMaxOpen)
        }
    }
    const pickStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        width: 'calc(100% - 75%)',
        bgcolor: 'background.paper',
        boxShadow: 24,
        cursor: 'pointer',
        p: 2,
        borderRadius: 10,
    }
    return (
        <>
            <DashboardLayout title={'Email & SMS Preferences'}>
                <SEO title="Email & SMS Preferences" url={window.location.href} />
                <div className="maTitle d-flex justify-content-between align-items-center w-100">
                    <Button
                        onClick={() => {
                            handleRedirectInternal(history, 'my-account')
                        }}
                        className="moveBack"
                    >
                        <span className="material-icons">keyboard_arrow_left</span>
                        {'Back to Account'}
                    </Button>
                </div>
                <div className="dashboardInner">
                    <h1 className="title mb-2">EMAIL AND TEXT NOTIFICATIONS</h1>
                    {/* <h1 className="title mb-2">EMAIL NOTIFICATIONS</h1> */}
                    <h5 className="dashSubtitle">
                        {SITE_NAME} can send email and SMS notifications based on your preferences
                        below. Email notifications about winning an item, and payment notifications,
                        cannot be overridden.
                    </h5>
                    {/* <h5 className="dashSubtitle">
                        {SITE_NAME} can send email notifications based on your preferences below.
                        Email notifications about winning an item, and payment notifications, cannot
                        be overridden.
                    </h5> */}
                    <div className="table-responsive dpTable notTable notiFy">
                        <form onSubmit={formikPreference.handleSubmit} autoComplete="nofill">
                            <table className="table text-left">
                                <thead>
                                    <tr>
                                        <th scope="col">{'Notification'}</th>
                                        <th scope="col" className="text-center">
                                            <span className="material-icons">email</span>
                                            <br />
                                            {'Email'}
                                        </th>
                                        <th scope="col" className="text-center">
                                            <span className="material-icons">phone_iphone</span>
                                            <br />
                                            {'Sms'}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {allNotifications.map((data, index) => (
                                        <>
                                            <tr
                                                key={data.id}
                                                hidden={
                                                    data.email == 0 && data.sms == 0 ? true : false
                                                }
                                            >
                                                <td
                                                    className="position-relative"
                                                    hidden={
                                                        data.email == 0 && data.sms == 0
                                                            ? true
                                                            : false
                                                    }
                                                >
                                                    <div className="d-flex">
                                                        <div
                                                            hidden={
                                                                data.email == 0 && data.sms == 0
                                                                    ? true
                                                                    : false
                                                            }
                                                        >
                                                            {data.description}
                                                        </div>{' '}
                                                        {data.description === 'Saved Search' ||
                                                        data.description === 'Trending' ? (
                                                            <img
                                                                className="infoIcon emailInfoIcon ml-2"
                                                                src="/assets/svg/infoIcon.svg"
                                                                onClick={() =>
                                                                    handleOpenMax(data.description)
                                                                }
                                                            />
                                                        ) : data.id === 6 || data.id === 9 ? (
                                                            // <span
                                                            //     style={{
                                                            //         color: 'red',
                                                            //         fontSize: '14px',
                                                            //     }}
                                                            // >
                                                            //     *
                                                            // </span>
                                                            <span
                                                                style={{
                                                                    marginLeft: '5px',
                                                                    fontSize: '14px',
                                                                }}
                                                            >
                                                                {' '}
                                                                (Required)
                                                            </span>
                                                        ) : null}
                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <div hidden={data.email == 0 ? true : false}>
                                                        <CustomCheckbox
                                                            checkedIcon={<WavyCheckIcon />}
                                                            checked={
                                                                formikPreference.values[
                                                                    'email_prefer'
                                                                ].indexOf(data.id.toString()) !== -1
                                                            }
                                                            onChange={(e) => {
                                                                const value = e.target.value
                                                                const currentValues =
                                                                    formikPreference.values
                                                                        .email_prefer
                                                                if (e.target.checked) {
                                                                    formikPreference.setFieldValue(
                                                                        'email_prefer',
                                                                        [...currentValues, value],
                                                                    )
                                                                } else {
                                                                    formikPreference.setFieldValue(
                                                                        'email_prefer',
                                                                        currentValues.filter(
                                                                            (v) => v !== value,
                                                                        ),
                                                                    )
                                                                }
                                                            }}
                                                            value={data.id.toString()}
                                                            disabled={
                                                                data.id === 6 || data.id === 9
                                                                    ? true
                                                                    : false
                                                            }
                                                            className={
                                                                data.id === 6 || data.id === 9
                                                                    ? 'customBgGrey'
                                                                    : ''
                                                            }
                                                        />
                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <div
                                                        hidden={
                                                            data.sms == 0 && data.id !== 6
                                                                ? true
                                                                : false
                                                        }
                                                    >
                                                        <CustomCheckbox
                                                            checkedIcon={<WavyCheckIcon />}
                                                            checked={
                                                                formikPreference.values[
                                                                    'sms_prefer'
                                                                ].indexOf(data.id.toString()) !== -1
                                                            }
                                                            onChange={(e) => {
                                                                const value = e.target.value
                                                                const currentValues =
                                                                    formikPreference.values
                                                                        .sms_prefer
                                                                if (e.target.checked) {
                                                                    formikPreference.setFieldValue(
                                                                        'sms_prefer',
                                                                        [...currentValues, value],
                                                                    )
                                                                } else {
                                                                    formikPreference.setFieldValue(
                                                                        'sms_prefer',
                                                                        currentValues.filter(
                                                                            (v) => v !== value,
                                                                        ),
                                                                    )
                                                                }
                                                            }}
                                                            value={data.id.toString()}
                                                            // disabled={data.id === 6 ? true : false}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        </>
                                    ))}
                                </tbody>
                            </table>
                            <div className="en-update-button">
                                <PrimaryButton
                                    id="notify_submit"
                                    btnSize="small"
                                    type="submit"
                                    label={'Update'}
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </DashboardLayout>
            <Modal
                open={isSavedOpen}
                onClose={handleOpenMax}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <Box sx={pickStyle}>
                    <span className="close-this-icon" onClick={() => handleOpenMax('Saved Search')}>
                        &times;
                    </span>
                    <Typography id="modal-description" sx={{ mt: 2 }}>
                        <p className="mb-2">
                            Saved Search stores a log of your wants/needs. Check the box to receive
                        </p>
                        <p className="mb-2">
                            notifications of new arrivals based on searches you have saved.
                        </p>
                        <p className="learnMore mb-0">Learn more</p>
                        <Link href="/terms-and-conditions">
                            <span className="terms">Terms & Conditions</span>
                        </Link>
                    </Typography>
                </Box>
            </Modal>
            <Modal
                open={isMaxOpen}
                onClose={handleOpenMax}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <Box sx={pickStyle}>
                    <span className="close-this-icon" onClick={() => handleOpenMax('Trending')}>
                        &times;
                    </span>
                    <Typography id="modal-description" sx={{ mt: 2 }}>
                        <p className="mb-2">
                            Receive notifications based on the most popular items on our site.
                        </p>
                        <p className="learnMore mb-0">Learn more</p>
                        <Link href="/terms-and-conditions">
                            <span className="terms">Terms & Conditions</span>
                        </Link>
                    </Typography>
                </Box>
            </Modal>
        </>
    )
}

export default Notifications
